import * as React from 'react'
import { getRandomColor, isColorDark, isValidHex } from '../../helpers'
import Icon from '../../components/ui/Icon'
import Input from '../../components/ui/Input'

import './index.css'

interface ColorGeneratorProps {
  startColor?: string
  onChange: (color: string) => void
}

const ColorGenerator = ({ startColor, onChange }: ColorGeneratorProps) => {
  const [color, setColor] = React.useState(startColor || getRandomColor())

  const newColor = () => {
    const color = getRandomColor()
    setColor(color)
    onChange(color)
  }

  const handleInput = (color: string) => {
    if (isValidHex(color)) {
      setColor(color)
      onChange(color)
    }
  }

  const style: React.CSSProperties = {
    backgroundColor: color,
  }
  if (isColorDark(color)) {
    style.fill = '#fff'
  }

  return (
    <div className="color-generator">
      <div
        id="color-generator-refresh"
        className="color-generator__box"
        onClick={newColor}
        style={style}
        data-testid="generate-color"
      >
        <Icon size="small" name="refresh" />
      </div>
      <Input
        type="text"
        value={color}
        onChange={handleInput}
        validator={input => isValidHex(input)}
        required
      />
    </div>
  )
}

export default ColorGenerator
